var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"transparent !important"}},[_c('icons'),_c('router-view',{key:_vm.$route.path + _vm.num})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }